import React, { FC, ReactElement } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { localizeType } from '../../commonType';
import { setHearingADACode, setRoomADACode } from '../../features/offerAvailability/offerAvailabilitySlice';
import { AvailableDates } from '../../features/offerAvailability/types';
import { RootState } from '../../redux/rootReducer';
import { adaCodes } from '../../util/Ada';
import { B4, none } from '../../util/strings';
import withLocalization from '../hoc/withLocalization';
import './ADASelector.scss';

interface ADAProps {
  localize: localizeType;
  onADASelectionChange: () => void;
}

const ADASelector: FC<ADAProps> = (props: ADAProps): ReactElement => {
  const { localize } = props;
  const availabilityDates: AvailableDates = useSelector((state: RootState) => state.availabilityDates);
  const adaStatus: boolean = availabilityDates.hearingADACode !== undefined;
  const selectedADARoomCode = availabilityDates.roomADACode;
  const dispatch = useDispatch();
  const handleADARoomTypeChange = (evt) => {
    dispatch(setRoomADACode(evt.target.value === none ? undefined : evt.target.value));
  };
  const handleHearingADASelectionChange = (evt) => {
    dispatch(setHearingADACode(evt.target.checked === true ? B4 : undefined));
  };

  return (
    <div className="row checkBoxWrapper">
      <div className="col-sm-12 ">
        <div className="premiumText">
          <div className="adaSelectorWrapper">
            <div className="select">
              {/* eslint-disable-next-line jsx-a11y/no-onchange */}
              <select name="slct" id="slct" onChange={handleADARoomTypeChange} defaultValue={selectedADARoomCode}>
                {adaCodes
                  .filter((x) => x.includeInOption)
                  .map((adaCode, index) => {
                    return (
                      <option key={index} value={adaCode.code}>
                        {localize(adaCode.title)}
                      </option>
                    );
                  })}
              </select>
            </div>
          </div>
          <label htmlFor="ada">
            <input id="ada" type="checkbox" defaultChecked={adaStatus} onChange={handleHearingADASelectionChange} />
            {localize('preview-sales-engine.static-content.copy.ADA.hearing')}
          </label>
        </div>
      </div>
    </div>
  );
};

export default withLocalization(ADASelector);
